<sn-searchbar
  (valueChange)="onSearchValueChange($event)"
  (search)="onSearchValueChange($event)"
  [placeholder]="'Search by name'"
  [clearOnNavEnd]="false"
></sn-searchbar>
<sn-data-list #list [fetchFn]="loadData">
  <sn-infinite-scroll>
    <sn-pull-to-refresh>
      <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
      <ng-template
        [ngIf]="!list.dataSource.data.length && list.dataIsInited"
        [ngIfThen]="emptyTmpl"
      ></ng-template>
    </sn-pull-to-refresh>
  </sn-infinite-scroll>
</sn-data-list>

<ng-template #listTmpl>
  <mat-table [dataSource]="list.dataSource.data">
    <ng-container *ngIf="multiple" matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="dragTool">
      <mat-header-cell *matHeaderCellDef>Tools</mat-header-cell>
      <mat-cell *matCellDef="let camera">
        <button
          class="cameraDragTool"
          mat-icon-button
          id="panorama-add-camera{{ camera.id }}"
          matTooltip="Drag and drop to place camera"
          cdkDrag
          (mousedown)="$event.stopPropagation()"
          (click)="$event.stopPropagation()"
          (cdkDragReleased)="onDragRelease($event, camera)"
          (cdkDragStarted)="onDragStart($event, camera)"
        >
          <sn-icon
            [class.spotHeading]="determineRotate(camera)"
            fontSet="fs"
            [fontIcon]="getIcon(camera)?.fontIcon"
          ></sn-icon>
        </button>

        <button
          mat-icon-button
          matTooltip="Orient Camera"
          [matMenuTriggerFor]="menu"
          (click)="$event.stopPropagation()"
        >
          <sn-icon fontSet="fal" fontIcon="fa-arrows-spin"></sn-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="cameraOrientation(camera, 90)">
            <span>90<span>&#176;</span></span>
          </button>
          <button mat-menu-item (click)="cameraOrientation(camera, 180)">
            <span>180<span>&#176;</span></span>
          </button>
          <button mat-menu-item (click)="cameraOrientation(camera, 270)">
            <span>270<span>&#176;</span></span>
          </button>
          <button mat-menu-item (click)="cameraOrientation(camera, 360)">
            <span>360<span>&#176;</span></span>
          </button>
        </mat-menu>

        <button
          *ngIf="isActive(camera.id)"
          mat-icon-button
          matTooltip="Go to camera"
          (click)="$event.stopPropagation(); goTo.next(camera)"
          (mousedown)="$event.stopPropagation()"
        >
          <sn-icon fontSet="fal" fontIcon="fa-location-crosshairs"></sn-icon>
        </button>
        <button
          *ngIf="isActive(camera.id)"
          mat-icon-button
          matTooltip="Remove camera from panorama"
          color="warn"
          (click)="$event.stopPropagation(); remove.next(camera)"
          (mousedown)="$event.stopPropagation()"
        >
          <sn-icon fontSet="fas" fontIcon="fa-trash-alt"></sn-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
      <mat-cell *matCellDef="let camera">
        <span class="fs-text-truncate">{{ camera.name }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="location">
      <mat-header-cell *matHeaderCellDef>Location</mat-header-cell>
      <mat-cell *matCellDef="let camera">
        <span class="fs-text-truncate">{{ camera.location ? camera.location.name : 'N/A' }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="floor">
      <mat-header-cell *matHeaderCellDef>Floor</mat-header-cell>
      <mat-cell *matCellDef="let camera">
        <span class="fs-text-truncate">{{ camera.floor ? camera.floor.name : 'N/A' }}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="owner">
      <mat-header-cell *matHeaderCellDef>Owner</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <sn-object-owner class="fs-text-truncate" [object]="item"></sn-object-owner>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="distance">
      <mat-header-cell *matHeaderCellDef>Distance (meters)</mat-header-cell>
      <mat-cell *matCellDef="let item"> {{ convertToMeters(item.distance) }}m </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row
      (click)="onSelected(camera)"
      *matRowDef="let camera; columns: columns"
      [class.activeCam]="isActive(camera.id)"
      [class.previewCam]="showPreviewCam && previewCamId === camera.id"
    >
    </mat-row>
  </mat-table>
</ng-template>

<ng-template #emptyTmpl>
  <sn-empty-state icon="cancel_presentation" title="No Results">
    No results match search criteria
  </sn-empty-state>
</ng-template>
